/**
 * Compare two hours objects for equality
 * @param {Object} hours1 - First hours object
 * @param {Object} hours2 - Second hours object
 * @returns {boolean} - True if hours are equal
 */
export const areWeekHoursEqual = (hours1, hours2) => {
	if (!hours1 && !hours2) return true;
	if (!hours1 || !hours2) return false;

	const days = [
		'sunday',
		'monday',
		'tuesday',
		'wednesday',
		'thursday',
		'friday',
		'saturday'
	];
	return days.every((day) => hours1[day] === hours2[day]);
};
